import request from '@/utils/request';

export function listNews(query) {
  return request({
    url: '/front/news/list',
    method: 'get',
    params: query,
    silent: true
  });
}

export function getLatestNews(limit = 5) {
  return request({
    url: '/front/news/latest',
    method: 'get',
    params: { limit },
    silent: true
  });
}

export function getNews(id) {
  return request({
    url: '/front/news/' + id,
    method: 'get',
    silent: true
  });
}
